import request from '@/utils/request'

/**
 * 验证电子印章点位（统一打卡接口）
 * @param {String} ruleCode 印章规则编码（sign_store_sealrule 表的 rule_code）
 * @param {Array} touchPoints 触摸点位数组 [[x1,y1], [x2,y2], [x3,y3], [x4,y4]]
 * @param {Number} activityUserId 用户活动参与记录ID（可选）
 */
export function validateSealPoints(ruleCode, touchPoints, activityUserId = null) {
    const data = {
        ruleCode: ruleCode,
        touchPoints: touchPoints
    }
    if (activityUserId != null) {
        data.activityUserId = activityUserId
    }
    return request({
        url: '/signstore/sealrule/compareSimilarity',
        method: 'post',
        data: data
    })
}

/**
 * 保存电子印章规则
 * @param {Object} data 规则数据 { ruleType, sealPoints, remark }
 */
export function saveSealRule(data) {
    return request({
        url: '/signstore/sealrule',
        method: 'post',
        data: data
    })
}

